/**
 * Transaction Collection Model
 */

define([
	'backbone',
	'underscore',
	'lib/wurfl',
	'model/activity/transactionModel',
	'model/activity/activityModel',
	'lib/prefetch-decorator',
	'lib/pxp'
], function (Backbone, _, wurfl, TransactionModel, ActivityModel, prefetches, pxp) {
	'use strict';

	var Transactions = Backbone.Collection.extend({

		model: TransactionModel,

		url: function () {
			return Backbone.history.options.root + 'activity';
		},

		/**
		 * Initialize the collection
		 * Bind the messageModel argument
		 * @param transactions - array - initial list of collections (handled by Backbone natively)
		 * @param options.messageModel - MessageModel instance - required
		 */
		initialize: function (transactions, options) {
			options = options || {};

			// module-level data for Summary and Activity pages
			this.activityModel = options.activityModel;

			// only for Activity page, ok if undefined on Summary
			this.messageModel = options.messageModel;
			this.filterModel = options.filterModel;

			// binds the triggerReset method to run in the context of this
			// object whenever it is invoked
			_.bindAll(this, 'triggerReset');

			// if someone makes a filter search going too far back, clear everything in the collection
			this.listenTo(Backbone, 'filter:bothDatesTooEarly', this.clearCollection);
		},

		/*
		 * Process AJAX response from server and return array of transactions to
		 * the collection as it expects.
		 *
		 * @param response {Object} - Response data from the server
		 */
		parse: function (response) {
			/**
			 * TODO this should just return activity.transactions and
			 * everything else should be set as attrs of the ActivityModel
			 */
			if (response.data && response.data.activity) {
				var activity = response.data.activity,
					transactions = activity.transactions;

				this.activityModel.setError(activity.error);

				this.user = response.user;
				this.hasTransactionsPending = activity.hasTransactionsPending;
				this.hasTransactionsCompleted = activity.hasTransactionsCompleted;
				this.isMerchantCategoryEnabled = activity.isMerchantCategoryEnabled;
				this.showLoadMore = activity.showLoadMore;
				this.nextPageToken = activity.nextPageToken;
				this.noOfTransactions = activity.noOfTransactions;

				// istanbul ignore if - all this is covered in MessageModel tests
				if (this.messageModel) {
					if (this.activityModel.hasError()) {
						// server returned error - clear any message
						this.messageModel.clearMessage();
					} else if (this.messageModel.filterModel.get('isNewSearch')) {
						// message is not updated if this is a request to load more txns
						// (hence isNewSearch check)
						this.messageModel.queueMessageFromResults({
							transactions: transactions,
							noOfTransactions: activity.noOfTransactions
						});
					}
				}

				if (this.filterModel) {
					this.filterModel.set('currencyCodes', activity.currencyCodes);
				}

				return transactions;
			}
		},

		/**
		 * Fetch transaction data and conditionally reset or append the collection with the results.
		 * @param params {Object} - Search criteria (see view/activity/filterView.js for details)
		 * @param isNewSearch {Boolean} - Determines whether results are appended or if the collection is reset
		 */
		load: function (params) {
			var args = { data: params },
				self = this;

			if (params.isNewSearch) {
				args.url = Backbone.history.options.root + 'activity/filter';
				args.reset = true;

				// Broadcast an event saying new search made
				args.success = function() {
					self.trigger('transactionCollection:newSearch', {});
				};
			} else {
				args.url = Backbone.history.options.root + 'activity/loadMore';
				args.remove = false;
				args.success = this.triggerReset;
			}

			// throw away obsolete property
			delete args.data.isNewSearch;

			this.fetch(args);
		},

		/**
		 * Not as simple as this.reset() because this collection is
		 * essentially managing 2 different collections using custom
		 * attributes
		 */
		clearCollection: function () {
			this.hasTransactionsPending = false;
			this.hasTransactionsCompleted = false;
			this.isMerchantCategoryEnabled = false;
			this.showLoadMore = false;
			this.reset();
		},

		/*
		 * Alternative way to tell collectionView to re-render
		 */
		triggerReset: function () {
			this.trigger('reset');
		}
	});

	/**
	 * Prefetch first 10 for Pending and complete transactions
	 * Using url query String: prefetch as trigger
	 */
	return prefetches(Transactions, function() {
		var urlDisableFlag = window.location.search.indexOf('prefetch=false') !== -1,
			prefetchExperimentEnabled = pxp.isTreatment('Prefetch_transaction_details_treatment'),
			transanctionNum = window.location.search.split('top=')[1] ? window.location.search.split('top=')[1] : 5;

		if (!urlDisableFlag && prefetchExperimentEnabled && !wurfl.isSmartPhone) {
			return [].concat(
				this.where({ status: 'PENDING', isPrefetchable: true }),
				this.where({ status: 'COMPLETED', isPrefetchable: true })
			).filter(_.identity).slice(0, transanctionNum);
		}
		return [];
	});
});



//////////////////
// WEBPACK FOOTER
// ./collection/activity/transactionCollection.js
// module id = 768
// module chunks = 0